export default "__VITE_ASSET__CclJd29___"